import { createApp } from 'vue'
import Cookies from 'js-cookie'

import CookieBanner from '../components/src/cookie-banner/CookieBanner'
import { LocalStorage } from '../components/src/common/helpers'

const appHandler = (homerunPrivacySettings, homerunI18n) => {
  const rootContainer = document.createElement('div')
  rootContainer.setAttribute('id', 'homerun-cookie-banner')
  document.body.appendChild(rootContainer)

  createApp(CookieBanner, {
    i18n: homerunI18n.cookieBanner,
    privacySettings: homerunPrivacySettings,
    loadAnalyticsCookies,
  }).mount('#homerun-cookie-banner')
}

const loadAnalyticsCookies = (homerunPrivacySettings) => {
  // Google Analytics 4
  function gtag() {
    (window.dataLayer = window.dataLayer || []).push(arguments)
  }

  // Load customer defined GA4 properties
  const ga4Ids = homerunPrivacySettings.customGA4Ids
  for (let i in ga4Ids) {
    // Google Analytics 4. Anonymized IPs is enabled by default.
    // 'config' command will automatically send a page view.
    gtag('js', new Date());

    let configInfo = {}
    if (homerunPrivacySettings.referrer) {
      configInfo.referrer = homerunPrivacySettings.referrer
    }

    gtag('config', ga4Ids[i], configInfo);
  }

  // Deny consent for all parameters by default
  // @see: https://support.google.com/tagmanager/answer/13695607
  gtag('consent', 'default', {
    'ad_storage': 'denied',
    'ad_user_data': 'denied',
    'ad_personalization': 'denied',
    'analytics_storage': 'granted'
  });

  // Load GTM
  (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    '//www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer',homerunPrivacySettings.gtmId);

  if (!Cookies.get('initial_referrer')) {
    Cookies.set('initial_referrer', document.referrer + '##' + window.location.hostname)
  }

  if (!Cookies.get('initial_params')) {
    Cookies.set('initial_params', window.location.search.substr(1) + '##' + window.location.hostname)
  }
}

export const loadCookieBanner = () => {
  const homerunPrivacySettings = window.homerunPrivacySettings || {}
  const homerunI18n = window.homerunI18n || {}

  if (LocalStorage.getItem('homerun-cookie-consent')?.dismissed === true) {
    return
  }

  if (LocalStorage.getItem('homerun-cookie-consent')?.confirmed === false) {
    return
  }

  if (LocalStorage.getItem('homerun-cookie-consent')?.confirmed === true) {
    loadAnalyticsCookies(homerunPrivacySettings)
    return
  }

  if (homerunPrivacySettings.askCookieConsent === false && homerunPrivacySettings.hasTrackingEnabled === true) {
    loadAnalyticsCookies(homerunPrivacySettings)
  }


  appHandler(homerunPrivacySettings, homerunI18n)
}

loadCookieBanner()
